import * as c from '../constants';
import _ from 'lodash';

export const modal = (state = c.INIT_STATE, action) => {
    switch(action.type) {
        case c.IS_OPEN:
            return _.assign({}, state, {
                modalIsOpen: action.isOpen
            });
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/common/reducers/index.js
 **/